var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.687,
    height: 21.715,
    viewBox: "0 0 21.687 21.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_880_",
    transform: "translate(-0.621 0.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1390_",
    d: "M19.408,12.819h-.044l-.333-1.444c1.107-.454,2.869-1.833,2.717-6a.341.341,0,0,0-.445-.312l-1.094.351c.133-1.145.242-3.766-1.241-5.315A.341.341,0,0,0,18.53.057a16.848,16.848,0,0,0-2.324,1.972,9.281,9.281,0,0,0-2.747,4.6H5.6A3.131,3.131,0,0,0,2.537,9.064L1.67,12.819H1.626A1.457,1.457,0,0,0,.171,14.274v3.489A1.457,1.457,0,0,0,1.6,19.218V20.35A1.252,1.252,0,0,0,2.851,21.6H3.89A1.252,1.252,0,0,0,5.141,20.35V19.219H15.893V20.35A1.252,1.252,0,0,0,17.144,21.6h1.04a1.252,1.252,0,0,0,1.251-1.251V19.218a1.457,1.457,0,0,0,1.429-1.455V14.274A1.457,1.457,0,0,0,19.408,12.819ZM17.731,8.285a.341.341,0,0,0,.384.044L19.3,7.7c-.064,2.033-.942,2.692-1.489,2.906a2.282,2.282,0,0,1-2.226-.3,2.189,2.189,0,0,1-.7-2.143c.278-1.791,2.192-3.392,2.9-3.926.6,1,.114,2.952-.146,3.673A.341.341,0,0,0,17.731,8.285ZM14.1,6.915C14.55,4.023,17.751,1.475,18.667.8c1.4,1.785.8,5.014.789,5.048a.341.341,0,0,0,.439.39l1.179-.379c.006,3.211-1.253,4.388-2.151,4.819A4.5,4.5,0,0,0,19.978,7.12a.341.341,0,0,0-.5-.289l-.968.515c.255-1.043.513-2.847-.415-3.815a.341.341,0,0,0-.437-.047c-.125.084-3.063,2.089-3.449,4.576a3.875,3.875,0,0,0-.047.584A4.268,4.268,0,0,1,14.1,6.915Zm-8.5.393h7.77a4.87,4.87,0,0,0,.064,1.224H3.471A2.451,2.451,0,0,1,5.6,7.308ZM3.2,9.217v0H13.624a3.7,3.7,0,0,0,1.164,1.609,4.09,4.09,0,0,0,2.567.882,4.422,4.422,0,0,0,1.024-.121l.285,1.236H2.37ZM4.459,20.35a.569.569,0,0,1-.568.568H2.851a.569.569,0,0,1-.568-.568V19.219H4.459V20.35Zm14.293,0a.569.569,0,0,1-.568.568h-1.04a.569.569,0,0,1-.568-.568V19.219h2.176Zm1.429-2.587a.774.774,0,0,1-.773.773H1.626a.774.774,0,0,1-.773-.773V14.275a.774.774,0,0,1,.773-.773H19.408a.774.774,0,0,1,.773.773v3.489Z",
    transform: "translate(0.5)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1408_",
    d: "M32.377,303.439a1.77,1.77,0,1,0,1.77,1.77A1.772,1.772,0,0,0,32.377,303.439Zm0,2.859a1.088,1.088,0,1,1,1.088-1.088A1.089,1.089,0,0,1,32.377,306.3Z",
    transform: "translate(-29.007 -289.19)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1411_",
    d: "M336.737,303.439a1.77,1.77,0,1,0,1.77,1.77A1.772,1.772,0,0,0,336.737,303.439Zm0,2.859a1.088,1.088,0,1,1,1.088-1.088A1.089,1.089,0,0,1,336.737,306.3Z",
    transform: "translate(-319.074 -289.19)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1412_",
    d: "M149.217,323.73h-6.67a.341.341,0,0,0,0,.682h6.67a.341.341,0,1,0,0-.682Z",
    transform: "translate(-135.365 -308.529)",
    stroke: "#000",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1413_",
    d: "M149.217,354.165h-6.67a.341.341,0,0,0,0,.682h6.67a.341.341,0,0,0,0-.682Z",
    transform: "translate(-135.365 -337.534)",
    stroke: "#000",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.bcf47e3246fcbd25390719ce95af6cb2.svg";
export { ForwardRef as ReactComponent };